import React, { FC, ReactNode, useEffect, useRef, useState } from "react";
import styles from "./FlightGuestCabinSelect.module.scss";
import { useTranslations } from "next-intl";
import FlightGuests from "../FlightGuests/FlightGuests";
import Person from "@/components/icons/Person/Person";
import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import { GuestIcon } from "@/components/icons";

export interface Passengers {
  adults: number;
  children: number;
  infants: number;
}

interface FlightGuestCabinSelectProps {
  onGuestChange: (passengers: Passengers) => void;
  onCabinClassChange: (cabinClass: string) => void;
cabinClass:string;
  passengers: Passengers;
  isBannerBox?: boolean;
  className?: string;
  icon?: ReactNode;
}

const FlightGuestCabinSelect: FC<FlightGuestCabinSelectProps> = ({
  onGuestChange,
  passengers,
  cabinClass,
  onCabinClassChange,
  isBannerBox,
  className,
  icon,
}) => {
  const t = useTranslations("guests");
  const trans = useTranslations("");
  // const [localPassengers, setlocalPassengers] = useState<Passengers>(passengers);
  const [isOpen, setIsOpen] = useState(false);
  const guestMenuRef = useRef<HTMLDivElement>(null);
  const [localPassengers, setLocalPassengers] = useState(passengers);
  const [localCabin, setLocalCabin] = useState(cabinClass);

  useEffect(() => {
    setLocalPassengers(passengers);
  }, [passengers]);

  useEffect(() => {
    setLocalCabin(cabinClass);
  }, [cabinClass]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        guestMenuRef.current &&
        !guestMenuRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const cabinOptions = [
    { label: trans("cabinClass.economy"), value: "E" },
    { label: trans("cabinClass.premiumEconomy"), value: "P" },
    { label: trans("cabinClass.business"), value: "B" },
    { label: trans("cabinClass.first"), value: "F" },
  ];

  const [selectedCabinClass, setSelectedCabinClass] = useState<string>("E");
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedCabinClass(event.target.value);
  };

  const handleApply = (updatedGuestData: Passengers) => {
    setLocalPassengers(updatedGuestData);
    onGuestChange(updatedGuestData);
  };

  const summaryTravelers = () => {
    const totalPassengers =
      localPassengers.adults + localPassengers.children + localPassengers.infants;
    const selectedCabinLabel =
      cabinOptions.find((opt) => opt.value === selectedCabinClass)?.label || "";

       const cabinLabelDisplay =
    selectedCabinLabel.length > 7
      ? `${selectedCabinLabel.slice(0, 7)}...`
      : selectedCabinLabel;

    return `${t("traveller", {
      count: totalPassengers,
    })} · ${cabinLabelDisplay}`;
  };

  return (
    <div
      className={`*
      
      flex-1 
      border 
      border-[#ffebbf] 
      border-l-0 
      rounded-tr-lg 
      rounded-br-lg 
      bg-white 
      min-w-[200px] 
      h-[56px] 
      px-4 
      flex 
      items-center 
      cursor-pointer
   ${className}`}
      data-testid="CustomSearchField"
      onClick={() => setIsOpen((prev) => !prev)}
      ref={guestMenuRef}
      role="button"
      tabIndex={0}
      aria-label="Toggle guest selection menu"
      onKeyDown={(event) => {
        if (event.key === "Enter" || event.key === " ") {
          setIsOpen((prev) => !prev);
        }
      }}
    >
              <GuestIcon className="text-primary" />

      <div className="ms-2 flex-1 relative">
        <span className="text-base font-normal whitespace-nowrap overflow-hidden text-ellipsis max-w-full">
          {summaryTravelers()}
        </span>

        {isOpen && (
          <div
            className={styles.dropDown}
            onClick={(event) => event.stopPropagation()}
            onKeyDown={(event) => {
              if (event.key === "Enter" || event.key === " ") {
                event.stopPropagation();
              }
            }}
            role="button"
            tabIndex={0}
            aria-label="Adjust guest rooms"
          >
            <div className="h-3 w-3 border-t border-l border-gray-200 absolute top-[1px] ltr:left-[15px] rtl:right-[20px] bg-white rotate-45"></div>
            <div className="w-[385px] rounded-md bg-white shadow-[0px_2px_12px_0px_rgba(0,0,0,0.12)] flex flex-col mt-2">
              <FlightGuests
                onApply={handleApply}
                passengers={localPassengers}
                onClose={() => setIsOpen(false)}
                hideDescription
              />

              <FormControl component="fieldset" className="!m-6">
                <FormLabel component="legend" className="!text-black !font-semibold">
                  {trans("searchForm.cabinClass")}
                </FormLabel>
                <RadioGroup
                  name="cabinClass"
                  value={selectedCabinClass}
                  onChange={handleChange}
                  className="!mt-2"
                >
                  {cabinOptions.map((option) => (
                    <FormControlLabel
                      key={option.value}
                      value={option.value}
                      control={
                        <Radio
                          sx={{
                            color: "#bc9a20",
                            "&.Mui-checked": {
                              color: "#bc9a20",
                            },
                          }}
                        />
                      }
                      label={option.label}
                    />
                  ))}
                </RadioGroup>
              </FormControl>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default FlightGuestCabinSelect;
